// Which form People shows in a tab's place, and which tab it stands in
// (01-the-console.md § conventions: a form; the tabs table, People). *Edit*
// names its row and the tab it was opened from — `edit:rules:own/roles/Admin`
// — so a refresh reopens it on that tab, over that row.

/** Tab is one of People's tabs. */
export type Tab = "members" | "rules";

/** The forms People shows in a tab's place: *Add a person*, *Add a rule*, and *Edit* of one row's role. */
export type PeopleForm = "person" | "rule" | `edit:${Tab}:${string}`;

/** editForm names the *Edit* of the row keyed `key`, opened from `tab`. */
export function editForm(tab: Tab, key: string): PeopleForm {
  return `edit:${tab}:${key}`;
}

/** editOf reads an *Edit* form's tab and row key back; undefined for any other form. */
export function editOf(form: string | undefined): { tab: Tab; key: string } | undefined {
  const m = /^edit:(members|rules):(.+)$/s.exec(form ?? "");
  return m === null ? undefined : { tab: m[1] as Tab, key: m[2] ?? "" };
}

/** formTab is the tab a form stands in: *Add a rule* in Access rules, *Add a person* in Members, an *Edit* in its own. */
export function formTab(form: string | undefined): Tab | undefined {
  if (form === "rule") {
    return "rules";
  }
  if (form === "person") {
    return "members";
  }
  return editOf(form)?.tab;
}
